import styled from "styled-components/macro";

export const WelcomeAuthButton = styled.button`
  width: 150px;
  font-weight: bold;
  font-size: 20px;
  background-color: white;
  color: #4384ff;
  padding: 10px;
  cursor: pointer;
  margin-left: 20px;
  margin-right: 20px;
  border-radius: 30px;
  border-color: black;
  border-width: 2px;
  outline: none;

  &:hover {
    background-color: #4384ff;
    color: white;
  }
`;

export const AuthButton = styled.button`
  width: 100px;
  font-weight: bold;
  font-size: 17px;
  background-color: white;
  color: #4384ff;
  padding: 5px;
  cursor: pointer;
  margin-left: 20px;
  margin-right: 20px;
  border-radius: 30px;
  border-color: black;
  border-width: 2px;
  outline: none;

  &:hover {
    background-color: #4384ff;
    color: white;
  }
`;
